const TipoMeta = Object.freeze({
  PARTICIPACAO: 'Participação'
});

export default TipoMeta;
